<script lang="ts">
    import ModalElement from "../ModalElement.svelte";
    import {_} from "svelte-i18n";
    import ExamType from "../ExamType.svelte";

    export let subjectData;
</script>

<div class="divider">{$_('subjectCard.general')}</div>
<ModalElement lead={$_('infoCard.credits')} text={subjectData.credits}/>
<ExamType text={subjectData.examType}/>
<ModalElement lead={$_('infoCard.lectures')} text={subjectData.lectures}/>
<ModalElement lead={$_('infoCard.practices')} text={subjectData.practices}/>
<ModalElement lead={$_('infoCard.lab')} text={subjectData.labPractices}/>

